/**
 * Manda el token en las rutas que la API protege: Sistema (usuarios, roles y permisos) y Cupones.
 *
 * Solo en estas: el backoffice en general no manda el token, y con token la API cambia
 * el body de otras rutas para usuarios de club.
 */
import axios from "axios";
import Vue from "vue";

const API_URL = process.env.VUE_APP_API_URL;
const PROTEGIDAS = [
  "/system/list-users",
  "/system/list-permissions",
  "/system/create-user",
  "/system/create-role",
  "/system/update-user/",
  "/system/update-role/",
  "/cupones/",
];

const esProtegida = (url = "") =>
  url.startsWith(API_URL) &&
  PROTEGIDAS.some((ruta) => url.slice(API_URL.length).startsWith(ruta));

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && esProtegida(config.url)) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Sesión sin token (iniciada antes de que la API lo pidiera) o con una contraseña que ya cambió:
// se pide volver a entrar en lugar de dejar la pantalla fallando
let avisado = false;
axios.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    if (error?.response?.status === 401 && esProtegida(error.config?.url) && !avisado) {
      avisado = true;
      const es = (localStorage.getItem("iso") || "es") !== "en";
      const salir = () => {
        const iso = localStorage.getItem("iso");
        localStorage.clear();
        if (iso) localStorage.setItem("iso", iso);
        window.location.href = "/";
      };
      // Diálogo y no toast: la pantalla abre su propio toast de error y lo taparía
      Vue.prototype.$buefy?.dialog.alert({
        title: es ? "Tu sesión expiró" : "Your session expired",
        message: es
          ? "Por seguridad, vuelve a iniciar sesión para continuar."
          : "For security, please log in again to continue.",
        confirmText: es ? "Iniciar sesión" : "Log in",
        type: "is-warning",
        hasIcon: true,
        icon: "lock",
        iconPack: "fas",
        canCancel: false,
        onConfirm: salir,
      });
      setTimeout(salir, 8000);
    }
    return Promise.reject(error);
  },
);
